import type { ScanJob } from '@repo/api-gw-sdk';

import {
  jobId,
  jobTemporalLink,
  jobResourceName,
  resourceId,
  resourceType,
  sourceAccountId,
  sourceRegion,
} from '@/components/queryBuilder/properties';
import type { FilterProperty } from '@/types/advanceFilter';

export const scanJobItemFields = [
  jobId,
  jobTemporalLink,
  jobResourceName,
  resourceType,
  resourceId,
] as FilterProperty<ScanJob>[];

export const sourceLocationFields = [
  sourceAccountId,
  sourceRegion,
] as FilterProperty<ScanJob>[];
